import { Address } from '.'
import { Selection } from '../enums'

export type PersonDto = {
  id?: number
  type: number
  address: BaseAddressDto
} & NaturalPersonDto & LegalPersonDto

export type PersonAdditionalData = {
  titleBefore: string | null
  titleAfter: string | null
  phone: string | null
  mobilePhonePrefix: string | null
  mobilePhone: string | null
  email: string | null
  agreement: boolean
  agreementOther?: boolean
  agent?: Agent
} & PersonDto

export type NaturalPersonDto = {
  birthNumber?: string
  name?: string
  surname?: string
  isForeigner: boolean
  birthday?: Date
  nationalityId?: number
}

export type LegalPersonDto = {
  idendificationNumber?: string
  companyName?: string
  isVatPayer?: boolean
}

export type BaseAddressDto = {
  postCode: string
  country: string
  city: string
  street?: string
  houseNumber?: string
  addressPoint?: number
  isEvidenceNumber?: boolean
}

export type Agent = {
  id: number | null
  titleBefore: string | null
  name: string | null
  surname: string | null
  required: boolean | null
}

export interface FindAddressResult {
  adresniMisto: number
  cisloDomovni?: string
  cisloOrientacni?: string
  typSo?: string
  psc: string
  ulice?: string
  obec: string
  castObce?: string
  adresa: string
}

export const formatPersonFullName = (person?: PersonAdditionalData) => {
  if (!person) return ''

  return ([Selection.Person, Selection.SelfEmployed].includes(person.type)
    ? `${person?.titleBefore ?? ''} ${person?.name ?? ''} ${person?.surname ?? ''} ${person?.titleAfter ?? ''
    }`
    : person.companyName ?? '')
    .trim()
}


export const formatPersonAddress = (address?: BaseAddressDto | Address) => {
  if (!address) return ''

  let ph = []

  let ulice = address.street ?? ''
  let obec = address.city ?? ''
  const cityParts = (address.city ?? '').split(' - ')
  if (!ulice) {
    if (cityParts.length == 2) {
      ulice = cityParts[1]
      obec = cityParts[0]
    }
    if (cityParts.length == 1) {
      ulice = obec
    }
  }

  const street = `${ulice} ${address.isEvidenceNumber ? 'č. ev. ' : ''}${address.houseNumber ?? ''}`
  if (!!street.trim()) ph.push(street)

  const city = `${address.postCode ?? ''} ${obec}`
  if (!!city.trim) ph.push(city)

  return ph.join(', ')
}

export const formatPerson = (person: PersonAdditionalData) => {
  let ph = []

  const fullname = formatPersonFullName(person)
  if (!!fullname?.trim()) ph.push(fullname)

  const address = formatPersonAddress(person.address)
  if (!!address.trim()) ph.push(address)

  return ph.join(', ')
}

export const formatPersonRcIco = (person?: PersonAdditionalData) => {
  if (!person) return ''

  return ((person.type == Selection.Person
    ? person.birthNumber : person.idendificationNumber) ?? '')
    .trim()
}